<template>
  <div class="main-container container-xxl">
    <titulo-grande texto="Cadastro de categorias de despesas" posicao="left" />

    <modal :tituloModal="textoBtnCadastro" @fecha_modal="fecha_modal" @hidden="fecha_modal"
      textoBtnChamada="Inserir Categoria" tamanho_modal="modal-md" @click_bt_modal="click_bt_modal" :exibe_botao="true">

      <template #default>
        <form @submit.prevent="register" enctype="multipart/form-data" id="cad_categoria_despesa">
          <fieldset>
            <InputText placeholder="" label="Nome da categoria *" tamanho="sm" nome="nome" ref="nome"
              v-model="nome" />

            <input type="submit" class="d-none" value="">
          </fieldset>
        </form>
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="register" class="btn btn-primary">Salvar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <modal tituloModal="" @fecha_modal="fecha_modal" @hidden="fecha_modal" textoBtnChamada="" tamanho_modal="modal-md"
      :exibe_botao="false" id_modal="modal_delete">
      <template #default>
        Tem certeza que deseja deletar a categoria <strong>"{{ titulo_delete }}"</strong>?
      </template>
      <template #botaoPersonalizado>
        <fieldset>
          <button type="button" @click.prevent="deletar" class="btn btn-danger"><i class="bi bi-trash3-fill"></i>
            Deletar
            <Spinner :visivel="false" id="loading" />
          </button>
        </fieldset>
      </template>
    </modal>

    <TabelaDatatable :dadosData="dadosData" dadosAjax="" :btnStatus="true" :btnEdit="true" :btnDelete="true"
      :ativa_placeholder="ativa_placeholder" :columns="colunas" @edit_status="edit_status" @edit_row="dados_editar"
      @delete_row="deletar_dados" modal_target_delete="#modal_delete"></TabelaDatatable>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import TituloGrande from '../../components/TituloGrande.vue'
import TabelaDatatable from '@/components/TabelaDatatable.vue';
import InputText from '@/components/form/InputText.vue';
import { AuthStore } from '@/stores/Auth';
import { api } from '@/services/api';
import { bloqueia_campos } from '@/assets/js/functions'
import { cadastrar, editar_status, deletar } from '@/assets/js/requests'
import { toastr } from '@/plugins/toast';

export default {
  components: { TituloGrande, Modal, TabelaDatatable, InputText },
  name: 'CadFinancasCategoriasDespesa',
  data() {
    return {
      auth: AuthStore(),
      id_delete: Number,
      id_dados: null,
      titulo_delete: String,
      nome: '',
      dadosData: '',
      colunas: [
        { data: 'nome', title: 'Nome', width: '80%' },
        { name: 'acoes', data: 'status', title: 'Ações', width: '10%' },
      ],
      textoBtnCadastro: 'Cadastro de Categoria de Notícia',
      ativa_placeholder: Boolean,
    }
  },
  mounted() {
    this.listagemTabela();
  },
  methods: {
    async listagemTabela() {
      this.ativa_placeholder = true
      this.dadosData = await api.get('finance/expense_category/list', { Authorization: this.auth.token })
      this.ativa_placeholder = false
    },
    async register(e) {
      e.preventDefault();
      if (!this.nome) {
        toastr.alerta("Digite o nome da categoria")
        return false;
      }
      const formu = document.querySelector("#cad_categoria_despesa")
      const dados = new FormData(formu)
      if (this.id_dados > 0) {
        dados.append('id',this.id_dados)
      }
      const registro = await cadastrar('finance/expense_category/register', dados);
      if (registro) {
        if (!this.id_dados) {
          this.limpa_campos()
        }
        this.listagemTabela()
      }
    },
    async edit_status(dados) {
      const edit = await editar_status('finance/expense_category/change_status', dados);
      if(edit){
        this.listagemTabela()
      }else{
        // this.$router.push('/login')
      }
    },
    async dados_editar(dados) {
      bloqueia_campos()
      var dadosEdit = await api.get('finance/expense_category/list/' + dados.rowData.id, { Authorization: this.auth.token })

      this.id_dados = dados.rowData.id;
      this.nome = dadosEdit.nome;

      document.querySelector("#btn_modal_cadastrar").click()
      bloqueia_campos(false)
    },
    fecha_modal() {
      this.limpa_campos()
    },
    limpa_campos() {
      this.nome = '';
      this.id_dados = null;
    },
    click_bt_modal() {
      if (this.id_dados > 0) {
        this.textoBtnCadastro = 'Editando categoria: ' + this.nome
      } else {
        this.textoBtnCadastro = 'Cadastrar categoria'
      }
    },
    deletar_dados(dados) {
      this.id_delete = dados.rowData.id
      this.titulo_delete = dados.rowData.nome
    },
    async deletar() {
      const delet = await deletar('finance/expense_category/delete', {id: this.id_delete});
      if(delet){
        this.listagemTabela()
      }
    }
  },
}
</script>

<style></style>